module.exports = __webpack_public_path__ + "static/media/superai_symbol_lg.2d133955.png";